import React from 'react'
import { ModelWithForm, WhenModelValue } from '@morningtrain/react-resources'
import Fieldset from 'layouts/form/Fieldset'
import * as Fields from 'support/fields'
import { ResourceSelector } from '@morningtrain/react-fields'
import { Translation, Translator } from '@morningtrain/react-translations'
import AdminPage from 'pages/app/AdminPage'
import GuestCount from 'pages/app/inventory/item/GuestCount'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { useRouter } from '@morningtrain/react-navigation'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import DepartmentNormsField from 'support/fields/custom/DepartmentNormsField'
import SaveItemAction from 'pages/app/inventory/item/SaveItemAction'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import * as Displays from 'support/displays'
import moment from "moment";

export default function Create () {
  const router = useRouter()
  const isCreating = router.currentRoute === 'app.inventory.item.create'

  return (
    <AdminPage>
      <Translator namespace='inventory.item'>
        <ModelWithForm resourceName='inventory.item'>
          <RedirectToEditOnCreatePipeline routeName='app.inventory.item.index' />

          <UI.PageHeader title={<TranslatedTitle name={isCreating ? 'create_title' : 'edit_title'} />}>
            <UI.ButtonWrap className='my-8'>
              <SaveItemAction />
            </UI.ButtonWrap>
          </UI.PageHeader>

          <UI.CardGroup>
            <UI.CardWithHeader header={<Translation name='headings.product_information' />}>
              <Fieldset cols={3}>
                <Translator namespace='inventory.item.fields'>
                  <Fields.Input name='name_da' label={<Translation name='fields.name_translations.da.label' />} />
                  <Fields.Input name='name_en' label={<Translation name='fields.name_translations.en.label' />} />
                  <Fields.Input name='sku' label={<Translation name='fields.sku.label' />} />
                  <UpdateModelOnChange name='is_category_dirty' value>
                    <UpdateModelOnChange name='inventory_category_id'>
                      <ResourceSelector
                        name='inventory_category_id'
                        optionsKey='name'
                        placeholder='Vælg kategori'
                        label={<Translation name='fields.category.label' />}
                        resourceName='inventory.category'
                        operationName='options'
                      />
                    </UpdateModelOnChange>
                  </UpdateModelOnChange>
                  <Fields.Input name='producer' label={<Translation name='fields.producer.label' />} />
                  <Fields.Input name='variant_id' label={<Translation name='fields.variant_id.label' />} />
                </Translator>
              </Fieldset>
            </UI.CardWithHeader>

            <UI.CardWithHeader header={<Translation name='headings.price_and_amount' />}>
              <Fieldset cols={3}>
                <Translator namespace='inventory.item.fields'>
                  <Fields.Input
                    name='min_unit'
                    label={<Translation name='fields.min_order.label' />}
                  />
                  <Fields.Select
                    enum='inventory_item_unit'
                    name='unit_type'
                    placeholder='-'
                    label={<Translation name='unit' />}
                  />
                  <Fields.Number
                    name='price'
                    label={<Translation name='fields.price.label' />}
                  />
                  <Fields.Number
                    name='amount_per_unit'
                    label={<Translation name='fields.amount_per_unit.label' />}
                  />
                  <Fields.Input
                    name='weight'
                    label={<Translation name='fields.weight.label' />}
                  />
                  <Fields.Number
                    name='start_price'
                    label={<Translation name='fields.start_price.label' />}
                  />
                  <Fields.Number
                    name='next_price'
                    label={<Translation name='fields.next_price.label' />}
                  />
                  <Fields.Date
                    name='price_change_date'
                    label={<Translation name='fields.price_change_date.label' />}
                    min={moment().add(1, 'd')}
                  />
                </Translator>
              </Fieldset>
            </UI.CardWithHeader>

            <UI.CardWithHeader header={<Translation name='headings.publish_settings' />}>
              <Fieldset cols={3}>
                <Fields.Date
                  name='valid_from'
                  label={<Translation name='fields.valid_from.label' />}
                />
                <Fields.Date
                  name='expires_at'
                  label={<Translation name='fields.expires_at.label' />}
                />
                <Fields.File name='image' label={<Translation name='fields.image.label' />}>
                  <WhenModelValue name='image' condition={null} negate>
                    <Displays.Image name='image' />
                  </WhenModelValue>
                </Fields.File>
              </Fieldset>
            </UI.CardWithHeader>

            <WhenModelValue name='norm_from_guest_count' condition={true}>
              <GuestCount isNorm={true} />
            </WhenModelValue>
            <WhenModelValue name='norm_from_guest_count' condition={false}>
              <GuestCount isNorm={false} />
            </WhenModelValue>

            <UI.CardWithHeader header={<Translation name='headings.norms' />}>
              <DepartmentNormsField name='norms' fromName='norms_by_weekday_and_department' naked />
            </UI.CardWithHeader>

          </UI.CardGroup>

        </ModelWithForm>
      </Translator>
    </AdminPage>
  )
}
